import { useEffect, useState } from "react";

export const useFilterLabel = () => {
  const [filterLabelName, setFilterLabelName] = useState("");
  const [filterLabelColor, setFilterLabelColor] = useState("");
  //ページ番号
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!!filterLabelName) {
      sessionStorage.setItem("filterLabelName", JSON.stringify(filterLabelName));
    }
  }, [filterLabelName]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("filterLabelName"));
    if (!!storageVar) {
      setFilterLabelName(storageVar);
    }
  }, []);

  useEffect(() => {
    if (!!filterLabelColor) {
      sessionStorage.setItem("filterLabelColor", JSON.stringify(filterLabelColor));
    }
  }, [filterLabelColor]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("filterLabelColor"));
    if (!!storageVar) {
      setFilterLabelColor(storageVar);
    }
  }, []);

  useEffect(() => {
    if (!!page && page !== 1) {
      sessionStorage.setItem("timelinepage", JSON.stringify(page));
    }
  }, [page]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("timelinepage"));
    if (!!storageVar) {
      setPage(storageVar);
    }
  }, []);

  const handleLabelFileter = (e) => {
    const { labelName, labelColor } = e.currentTarget.dataset;
    setFilterLabelName(labelName);
    setFilterLabelColor(labelColor);
    setPage(1);
  };

  //カレンダー日付
  const [calendarDate, setCalendarDate] = useState(Date().toISOString);
  useEffect(() => {
    if (!!calendarDate) {
      sessionStorage.setItem("calendarDate", JSON.stringify(calendarDate));
    }
  }, [calendarDate]);
  useEffect(() => {
    const storageVar = sessionStorage.getItem("calendarDate");
    if (!!storageVar && storageVar !== "undefined") {
      setCalendarDate(JSON.parse(storageVar));
    }
  }, []);

  return {
    filterLabelName,
    filterLabelColor,
    page,
    setPage,
    calendarDate,
    setCalendarDate,
    handleLabelFileter,
  };
};
